import ControllerBase from '../../../../global/js/ControllerBase';

interface ComponentRefs {
	loadButton: 'loadButton';
}
export default class ControllerGridContainer extends ControllerBase<ComponentRefs> {
	private button: HTMLAnchorElement;

	constructor(element: HTMLElement) {
		super(element);
		this.button = this.$references.loadButton as HTMLAnchorElement;

		this.displayAllElements();

		this.paginationHandler();
	}

	private displayAllElements(): void {
		this.button && this.button.addEventListener('click', (e) => {
			e.preventDefault();

			const loadElement = this.button.parentElement?.dataset.identifierLoad;

			const hiddenItems = this.$element.querySelectorAll(
				`.o-gridcontainer[data-identifier-load="${loadElement}"] .o-grid-container__gridElement,uk-hidden`,
			);

			hiddenItems &&
				hiddenItems.forEach((e) => {
					e.classList.remove('uk-hidden');
				});

			this.button.classList.add('uk-hidden');
		});
	}

	private paginationHandler(): void {
		const pagination = document.querySelectorAll('.uk-pagination li a');
		let elementToGo = '0';

		pagination.forEach((element) => {
			element?.addEventListener('click', (e) => {
				e.preventDefault();

				const clickedPag = (<HTMLElement>e.target).getAttribute('href')?.split('-')[1];
				const currentElement = (<HTMLElement>document.querySelector('.o-grid-container .o-gridcontainer > div:not(.uk-hidden)')).getAttribute(
					'pagindex',
				);

				if (clickedPag != 'prev' && clickedPag != 'next') {
					//Updatge content
					document.querySelectorAll('.o-grid-container .o-gridcontainer > div').forEach((gridElement) => {
						if ((<HTMLElement>gridElement).getAttribute('pagindex') == clickedPag) {
							(<HTMLElement>gridElement).classList.remove('uk-hidden');
						} else {
							(<HTMLElement>gridElement).classList.add('uk-hidden');
						}
					});

					//Update navigation active
					document.querySelectorAll('.uk-pagination li a').forEach((activeElement) => {
						if ((<HTMLElement>activeElement).getAttribute('href') == (<HTMLElement>e.target).getAttribute('href')) {
							(<HTMLElement>activeElement).parentElement?.classList.add('uk-active');
						} else {
							(<HTMLElement>activeElement).parentElement?.classList.remove('uk-active');
						}
					});
				} else {
					if (clickedPag == 'prev') {
						if (currentElement != '1') {
							if (currentElement) {
								elementToGo = (parseInt(currentElement) - 1).toString();
							}
						}
					} else {
						if (
							currentElement !=
							(<HTMLElement>document.querySelector('.o-grid-container .o-gridcontainer > div:last-child')).getAttribute('pagindex')
						) {
							if (currentElement) {
								elementToGo = (parseInt(currentElement) + 1).toString();
							}
						}
					}

					//Update content
					document.querySelectorAll('.o-grid-container .o-gridcontainer > div').forEach((gridElement) => {
						if ((<HTMLElement>gridElement).getAttribute('pagindex') == elementToGo) {
							(<HTMLElement>gridElement).classList.remove('uk-hidden');
						} else {
							(<HTMLElement>gridElement).classList.add('uk-hidden');
						}
					});

					//Update navigation active
					document.querySelectorAll('.uk-pagination li a').forEach((activeElement) => {
						if ((<HTMLElement>activeElement).getAttribute('href') == '#pag-' + elementToGo) {
							(<HTMLElement>activeElement).parentElement?.classList.add('uk-active');
						} else {
							(<HTMLElement>activeElement).parentElement?.classList.remove('uk-active');
						}
					});
				}
			});
		});
	}
}
